import React from 'react';
import '../loading.css'; // You can create a CSS file for styling

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loader"></div>
      <div className="loading-text">Loading Projects</div>
    </div>
  );
};

export default Loading;